let lastScrollTop = 0;

function init() {
  const fixedHeaders = document.querySelectorAll('#header-custom, #header-custom--laptop');

  window.addEventListener('scroll', () => {
    if (!fixedHeaders) { return; }

    const scrollTop = window.scrollY;
    
    if (scrollTop === lastScrollTop) { return; }
    
    const isScrollingDown = scrollTop > lastScrollTop;
    const isTop = (scrollTop <= 130);
    const hideHeader = isScrollingDown && !isTop;
    
    fixedHeaders.forEach(h => h.classList.toggle('header-custom--hidden', hideHeader));
    lastScrollTop = scrollTop;
  });
}

export default { init }